/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import {
  Alert,
  Autocomplete,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Link,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Add as AddIcon } from "@mui/icons-material";
import Loading from "../components/Loading";
import axios from "../../CustomAxios";

function UpdateProductionReport() {
  const [companies, setCompanies] = useState(false);
  const [selectedApCompany, setSelectedApCompany] = useState("");
  const [jobs, setJobs] = useState([{ label: "" }]);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const { production_id } = useParams();

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const snackRef = useRef(null);
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const [dpr, setDpr] = useState();

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const [jobData, setJobData] = useState({
    job_id: "",
    name: "",
    plates: [],
    plate_id: "",
    baking_quantity: 0,
    ctp_quantity: 0,
    ap_user_name: "",
    comment: "",
    unique_id: ""
  });
  const [maxbakeandCtp, setmaxbakeandCtp] = useState({
    maxBake: 0,
    maxCtp: 0,
  });
  const [totalQuantity, setTotalQuantity] = useState({
    ctp: 0,
    bake: 0,
  });
  const [loader, setLoader] = useState(true);
  const [plates, setPlates] = useState([
    {
      plateId: "",
      baking_quantity: "",
      ctp_quantity: "",
    },
  ]);
  const [show, setShow] = useState(false);

  const getPlateDetails = async (tempPlates) => {
    let rows = [];
    await Promise.all(
      tempPlates.map(async (element, index) => {
        try {
          const authData = JSON.parse(localStorage.getItem("AuthData"));
          const config = {
            headers: {
              Authorization: "Bearer " + authData.access_token,
            },
          };
          const { data } = await axios.get(
            `/api/v1/${authData?.type}/plate_inventory/${element.plate_id}/details`,
            config
          );
          rows.push({
            label: `${data.data.height}X${data.data.width}X${data.data.thickness}`,
            id: element._id,
            bake: element.bake,
            ctp: element.ctp_plate_count,
            plate_id: element.plate_id,
          });
        } catch (error) {
          setErr("Error in fetching plate details");
        }
      })
    );
    return rows;
  };

  const handleSubmit = async () => {
    try {
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      if (
        !jobData.job_id ||
        jobData.ctp_quantity === undefined ||
        jobData.baking_quantity === undefined ||
        !jobData.plate_id
      ) {
        showErrorAlert("All fields are required");
        return;
      }


      let desc = "";
      let noChange = true;
      if (jobData.job_id !== dpr.job_id._id) {
        desc += `Job changed from ${dpr.job_id.job_id} to ${jobData.code}:`;
        noChange = false;
      } else {
        desc += `Job id ${jobData.code}:`;
      }
      if (jobData.plate_id !== dpr.plate._id) {
        let dt = jobData.plates.find((p) => p.id === jobData.unique_id).label;
        desc += `Plate changed from ${dpr.plate.width}x${dpr.plate.height}x${dpr.plate.thickness} to ${dt}:`;
        noChange = false;
      } else {
        let dt = jobData.plates.find((p) => p.id === jobData.unique_id).label;

        desc += `Plate ${dt}:`;
      }
      if (jobData.baking_quantity !== dpr.baking_quantity) {
        desc += `Bake quantity changed from ${dpr.baking_quantity} to ${jobData.baking_quantity}:`;
        noChange = false;
      }
      if (jobData.ctp_quantity !== dpr.ctp_quantity) {
        desc += `Ctp quantity changed from "${dpr.ctp_quantity}" to "${jobData.ctp_quantity}":`;
        noChange = false;
      }
      if (jobData.comment !== dpr.comment) {
        noChange = false;
        desc += `Comment change from ${dpr.comment} to ${jobData.comment}`;
      }

      if (noChange) {
        showErrorAlert("No changes made");
        return;
      }

      const report = {
        job_id: jobData.job_id,
        plate: jobData.plate_id,
        baking_quantity: jobData.baking_quantity,
        ctp_quantity: jobData.ctp_quantity,
        comment: jobData.comment,
        unique_id: jobData.unique_id,
        // ap_company: apCompany,
        audit_logs: [
          {
            action_by: authData.user_id,
            timestamp: new Date(),
            action: "update_dpr",
            description: desc,
          },
        ],
      };

      // console.log("report is", finalobj);
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${authData?.type}/production_report/${production_id}`,
        report,
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        navigate(
          `/dashboard/production-report?ap_company=${selectedApCompany}`,
          {
            state: {
              success: true,
              message: "DPR Updated Successfully",
            },
          }
        );
      }
    } catch (e) {
      console.log(e, 'error')
      setLoader(false);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };

  const handleApCompanyClick = async (newValue, dpr_data) => {
    setSelectedApCompany(newValue);

    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };

    const data = await axios.get(
      `/api/v1/${authData?.type}/jobs/?ap_company_id=${newValue}`,
      config
    );
    // console.log("Data for plates is", data.data.data.data);
    let tempData = data.data.data.data;

    let rows = [];
    // eslint-disable-next-line
    let job_plt = [];
    const temp = tempData.map((element, index) => {
      if (element.job_id === dpr_data.job_id.job_id)
        job_plt.push(element.plates);
      if (
        element.current_status !== "new" &&
        element.current_status !== "requested" &&
        element.current_status !== "studio"
      ) {
        rows.push({
          label: element.job_id,
          id: element._id,
          name: element.name,
          plates: element.plates,
        });
        return element;
      }
    });
    setJobs(rows);
    let pltrows = await getPlateDetails(job_plt[0]);
    let dt = pltrows.find((n) => n.id === dpr_data.unique_id);

    setmaxbakeandCtp({
      maxBake: dt.bake,
      maxCtp: dt.ctp,
    });
    setJobData({
      job_id: dpr_data.job_id._id,
      code: dpr_data.job_id.job_id,
      name: dpr_data.job_id.name,
      ctp_quantity: dpr_data?.ctp_quantity,
      baking_quantity: dpr_data.baking_quantity,
      plate_id: dpr_data.plate._id,
      plates: pltrows,
      comment: dpr_data.comment,
      unique_id: dpr_data.unique_id
    });

    // setPlateData(rows);
    setLoader(false);
  };

  async function getData() {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${userData?.type}/production_report/${production_id}`,
      config
    );
    setDpr(data.data);
    getTotalDPR(data.data.job_id._id, data.data.unique_id);
    handleApCompanyClick(data.data.ap_company._id, data.data);
  }

  const getTotalDPR = async (job_id, unique_id) => {
    try {
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${authData?.type}/production_report/total/${job_id}/${unique_id}`,
        config
      );
      // console.log(data.data.ctp, "data");
      setTotalQuantity({
        ctp: data.data?.ctp === undefined ? 0 : data.data.ctp,
        bake: data.data?.bake === undefined ? 0 : data.data.bake,
      });
      setShow(true);
    } catch (error) {
      console.log(error);
      setErr("Error in fetching total quantity");
    }
  };

  //

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function showErrorAlert(message) {
    setErr(message);
    snackRef.current.click();
  }

  return (
    <>
      <form noValidate autoComplete="off">
        <Button
          ref={snackRef}
          style={{ display: "none" }}
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Click
        </Button>

        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          {err ? (
            <Alert mt={2} mb={4} severity="error">
              {err}
            </Alert>
          ) : success ? (
            <Alert mt={2} mb={4} severity="success">
              DPR Updated Successfully
            </Alert>
          ) : null}
        </Snackbar>
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              Update Production Report
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/production-report">
                Production Report
              </Link>

              <Typography>Update</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        {!loader ? (
          <>
            <Card mb={6}>
              <CardContent>
                <Paper elevation={3} style={{ padding: "2%" }}>
                  <Grid container spacing={5}>
                    {show && (
                      <Grid item xs={12}>
                        <Alert mt={2} mb={4} severity="info">
                          {"Total CTP quantities added- " +
                            totalQuantity.ctp +
                            ", Total Bake Quantity added- " +
                            totalQuantity.bake}
                        </Alert>
                      </Grid>
                    )}
                    <Grid item xs={12} lg={12} md={12}>
                      <Typography variant="h6" gutterBottom>
                        AP Company
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <TextField
                        fullWidth
                        label="AP Company name"
                        value={dpr?.ap_company.name}
                      />
                    </Grid>

                    {!loader && (
                      <>
                        {/* <div style={{ display: "flex", alignItems: "center" }}> */}
                        <Grid item xs={12} md={2} lg={2}>
                          <Autocomplete
                            disablePortal
                            size="small"
                            options={jobs}
                            disableClearable={true}
                            defaultValue={dpr.job_id.job_id}
                            onChange={async (e, newValue, reason) => {
                              if (reason === "clear") {
                                setJobData({
                                  job_id: "",
                                  name: "",
                                  plate_id: "",
                                  plates: [],
                                  ctp_quantity: 0,
                                  baking_quantity: 0,
                                });
                                showErrorAlert("Please select job");
                                return;
                              }
                              const tempPlates = newValue.plates;
                              const rows = await getPlateDetails(tempPlates);
                              let pltrows = await getPlateDetails(tempPlates);

                              setJobData({
                                job_id: newValue.id,
                                name: newValue.name,
                                code: newValue.label,
                                plate_id: "",
                                plates: pltrows,
                                ctp_quantity: 0,
                                baking_quantity: 0,
                              });
                              setShow(false);
                              setmaxbakeandCtp({
                                maxBake: 0,
                                maxCtp: 0,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Job Id" />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={2} lg={2}>
                          <TextField
                            size="small"
                            sx={{ width: "100%" }}
                            // name={String(index)}
                            value={jobData.name}
                            // value={job.name}
                            label="Job Name"
                          />
                        </Grid>

                        <Grid item xs={12} md={2} lg={2}>
                          <Autocomplete
                            disablePortal
                            size="small"
                            value={
                              jobData.plates.find(
                                (n) => n.id === jobData.unique_id
                              ) || ""
                            }
                            options={jobData.plates}
                            getOptionLabel={(option) => {
                              return option.label || "no plate";
                            }}
                            onChange={(e, newValue) => {
                              // const updatedJobDetails = [...jobData];
                              const selectedPlate = jobData.plates.find(
                                (plate) => plate.id === newValue.id
                              );
                              setJobData({
                                ...jobData,
                                plate_id: selectedPlate.plate_id,
                                unique_id: newValue.id,
                                baking_quantity: 0,
                                ctp_quantity: 0
                              });
                              setmaxbakeandCtp({
                                maxBake: selectedPlate.bake,
                                maxCtp: selectedPlate.ctp,
                              });
                              getTotalDPR(jobData.job_id, newValue.id);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Plates" />
                            )}
                          />
                        </Grid>

                        <Grid item xs={12} md={2} lg={2}>
                          <TextField
                            size="small"
                            // name={String(index)}
                            sx={{ width: "100%" }}
                            onChange={(e) => {
                              // const updatedPlates = [...jobData];
                              if (e.target.value > maxbakeandCtp.maxBake) {
                                showErrorAlert(
                                  "Please enter a lower amount; you are exceeding the maximum bake quantity"
                                );
                                return;
                              }

                              if (
                                parseInt(e.target.value) +
                                parseInt(totalQuantity.bake) >
                                parseInt(maxbakeandCtp.maxBake)
                              ) {
                                showErrorAlert(
                                  "Cannot make entry as the total will exceed max bake quantity"
                                );
                                return;
                              }

                              setJobData({
                                ...jobData,
                                baking_quantity: e.target.value,
                              });

                              // updatedPlates[
                              //   Number(e.target.name)
                              // ].baking_quantity = Number(e.target.value);
                              // setJobData(updatedPlates);
                            }}
                            value={jobData.baking_quantity}
                            label="bake"
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={1}
                          lg={1}

                        // sx={{ paddingLeft: "5px", marginRight: "20px" }}
                        >
                          <TextField
                            size="small"
                            sx={{ width: "100%" }}
                            value={maxbakeandCtp.maxBake}
                            disabled
                            label="Max Bake"
                          />
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          md={2}
                          lg={2}

                        // sx={{
                        //   borderRight: "1px solid #ccc",
                        //   paddingRight: "7px",
                        // }}
                        >
                          <TextField
                            size="small"
                            sx={{ width: "100%" }}
                            // name={String(index)}
                            onChange={(e) => {
                              // const updatedPlates = [...jobData];
                              if (e.target.value > maxbakeandCtp.maxCtp) {
                                showErrorAlert(
                                  "Please enter a lower amount; you are exceeding the maximum ctp quantity"
                                );
                                return;
                              }

                              if (
                                parseInt(e.target.value) +
                                parseInt(totalQuantity.ctp) >
                                parseInt(maxbakeandCtp.maxCtp)
                              ) {
                                showErrorAlert(
                                  "Cannot make entry as the total will exceed max CTP quantity"
                                );
                                return;
                              }
                              setJobData({
                                ...jobData,
                                ctp_quantity: e.target.value,
                              });
                            }}
                            value={jobData.ctp_quantity}
                            label="ctp"
                          />
                        </Grid>
                        <Grid item xs={12} md={1} lg={1}>
                          <TextField
                            size="small"
                            sx={{ width: "100%" }}
                            value={maxbakeandCtp.maxCtp}
                            // value={plateMaxCtpMap[jobData[index].plate_id] || 0}
                            disabled
                            label="Max CTP"
                          />
                        </Grid>

                        <Grid item xs={12} md={12} lg={12}>
                          <TextField
                            size="small"
                            sx={{ width: "100%" }}
                            value={jobData.comment}
                            onChange={(e) => {
                              setJobData({
                                ...jobData,
                                comment: e.target.value,
                              });
                            }}
                            // value={plateMaxCtpMap[jobData[index].plate_id] || 0}
                            label="Comment"
                          />
                        </Grid>

                        {/* </div> */}
                      </>
                    )}
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <Button
                      onClick={handleSubmit}
                      mr={2}
                      variant="contained"
                      color="primary"
                      style={{ textAlign: "center", marginTop: "20px" }}
                    >
                      Update DPR
                    </Button>
                  </Grid>
                </Paper>
              </CardContent>
            </Card>

            {/* <div style={{ display: "flex", justifyContent: "flex-start" }}>
             
            </div> */}
          </>
        ) : (
          <Loading />
        )}
      </form>
    </>
  );
}

export default UpdateProductionReport;
